
























import { sanitize } from "@/api/helpers";
import { Tag, Work } from "@/api/models";
import { notEmptyString } from "@/api/validators";
import { bus } from "@/main";
import { SubmissionState } from "@/store/types";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import HelpWidget from "./HelpWidget.vue";

@Component({
  components: { HelpWidget },
})
export default class TagField extends Vue {
  @Prop({ default: "Tags" }) label: string;
  @Prop({ default: "themes" }) name: string;
  @Prop({ default: () => [] }) tags: Array<Tag>;
  @Prop({ default: () => [] }) tagList: Array<Tag>;
  @Prop({ default: 12 }) maxTags: Array<Tag>;
  @Prop({ default: "" }) workId: string;
  @Prop({ default: () => [] }) excludeSlugs: string[];
  @State("submission") submission: SubmissionState;

  tagWords: Array<Tag|string> = [];
  filteredTags: Array<Tag> = [];

  created() {
    this.sync();
    bus.$on('update-tags', ({name, id}: { name: string; id: string}) => {
      if (name === this.name) {
        if (name.startsWith("work") && id === this.workId || notEmptyString(name)) {
          this.sync();
        } 
      }
    });
  }

  mounted() {
    setTimeout(this.sync, 500);
  }

  sync() {
    this.tagWords = this.tags.map((tg) => tg.text);
  }

  getFilteredTags(text: string) {
    const rgx = new RegExp(
      "\\b" + text.trim().replace(/[^a-z0-9]+/gi, ".*") + "[^ ]+\\b",
      "i"
    );
    this.filteredTags = this.tagList.map(tag => new Tag(tag)).filter((tg) => {
      return rgx.test(tg.slug) || rgx.test(tg.text);
    });
  }

  add() {
    this.tagWords = this.tagWords.map((tg) => {
      if (tg instanceof Object) {
        return tg;
      } else {
        return this.mapTextToTags(tg);
      }
    }).filter(tg => this.excludeSlugs.includes(tg.slug) === false);
  }

  get tagListString() {
    return this.tags.map((tg) => tg.text).join(", ");
  }

  mapTextToTags(inData = null) {
    let text = "";
    let slug = "";
    let count = -1;
    if (typeof inData === "string") {
      text = inData;
      slug = sanitize(text);
    } else if (inData instanceof Object) {
      if (inData.slug) {
        slug = inData.slug;
      }
      if (inData.text) {
        text = inData.text;
      }
      if (inData.total && typeof inData.total === "number") {
        count = inData.total;
      } else if (inData.count && typeof inData.count === "number") {
        count = inData.count;
      }
    }
    return new Tag({
      slug,
      text,
      count
    });
  }

  @Watch("tagWords")
  changeTagWords() {
    switch (this.name) {
      case "submission.themes":
        this.submission.themes = this.tagWords.map(this.mapTextToTags);
        break;
      case "submission.tags":
        this.submission.tags = this.tagWords.map(this.mapTextToTags).filter(tg => this.excludeSlugs.includes(tg.slug) === false);
        break;
      case "work.themes":
        this.updateWork();
        break;
    }
  }

  updateWork() {
    const work = this.submission.works.find((w) => this.workId === w._id);
    if (work instanceof Work) {
      work.themes = this.tagWords
        .map(this.mapTextToTags)
        .filter((tg) => tg.slug.length > 0 && this.excludeSlugs.includes(tg.slug) === false);
      bus.$emit("work-themes-updated", { workId: this.workId });
    }
  }

  @Watch("workId")
  changeWorkId() {
    this.sync();
  }

  @Watch("name")
  changeName() {
    this.sync();
  }
}
